export const environment = {
    production: true,
    firebaseConfig: {
        apiKey: "AIzaSyAOFbsL1Ku2veJyMJ7PTKPA_MrBmYJjw7U",
        authDomain: "chiesi-27bd6.firebaseapp.com",
        projectId: "chiesi-27bd6",
        storageBucket: "chiesi-27bd6.firebasestorage.app",
        messagingSenderId: "113848921883",
        appId: "1:113848921883:web:c92b3e6169d341f5086dbe",
        measurementId: "G-19SXVPQW8P"
    },
    appleStoreId: '1541081204',
    googleStoreId: 'br.com.icons4u.chiesi',
    googleMapsApiKey: 'AIzaSyAuQXtBFboYfCZoWuAdqybfAphPbOmudZg',
    config: {
        local: {
            _site: 'https://app.dev.pdag.chiesi.com.br/',
            //_media: 'https://media.dev.vitrinedeamostras.app.br/',
            _media: 'https://s3-prod-icons4u.us-east-1.linodeobjects.com/timeclub/',
            urlApiPadrao: 'http://localhost:3014/',
            // urlApiPadrao: 'https://api.dev.pdag.chiesi.com.br/',
            X_TOKEN_API: '262e4801adb5dfe5611a4a83c68365a591f14c48',
            debugMode: 'info'
        },
        dev: {
            _site: 'https://app.dev.pdag.chiesi.com.br/',
            _media: 'https://media.dev.timeclub.app.br/',
            urlApiPadrao: 'https://api.dev.pdag.chiesi.com.br/',
            X_TOKEN_API: '262e4801adb5dfe5611a4a83c68365a591f14c48',
            debugMode: 'info'
        },
        hom: {
            _site: 'https://app.dev.pdag.chiesi.com.br/',
            _media: 'https://media.hom.timeclub.app.br/',
            urlApiPadrao: 'https://api.dev.pdag.chiesi.com.br/',
            X_TOKEN_API: '262e4801adb5dfe5611a4a83c68365a591f14c48',
            debugMode: 'off'
        },
        prod: {
            _site: 'https://app.pdag.chiesi.com.br/',
            //_media: 'https://media.timeclub.app.br/',
            _media: 'https://s3-prod-icons4u.us-east-1.linodeobjects.com/timeclub/',
            urlApiPadrao: 'https://api.pdag.chiesi.com.br/',
            X_TOKEN_API: '262e4801adb5dfe5611a4a83c68365a591f14c48',
            debugMode: 'off'
        }
    }
};